<template>
	<div class="app-dashboard">
		<div class="header">
			<h1>{{ $t('base.general.dashboard') }}</h1>
		</div>
		<div class="body">
			<spinner v-if="user.loading || accounts.loading || alerts.loading || patients.loading"/>
			<div v-else>
				<alerts-widget
					:user_uid="user_uid"
					:alerts="alerts.data"/>
				<watches-widget
					v-check-user:patients="selectedAccount"
					:user_uid="user_uid"
					:watches="patients.data"/>
			</div>
		</div>
	</div>
</template>

<script>
import AlertsWidget from '@/components/widgets/AlertsWidget'
import WatchesWidget from '@/components/widgets/WatchesWidget'
export default {
	components: {
		AlertsWidget,
		WatchesWidget
	},
	props: [
		'user_uid'
	],
	computed: {
		user () {
			return this.$store.state.user
		},
		accounts () {
			return this.$store.state.accounts
		},
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		alerts () {
			return this.$store.getters.getAccountAlertsUnread(this.selectedAccount)
		},
		patients () {
			return this.$store.getters.getAccountWatches(this.selectedAccount)
		}
	},
	beforeCreate () {
		this.$title('Dashboard')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue